import { Component, Input } from '@angular/core';

@Component({
  selector: 'iv-fee-totals',
  templateUrl: './fee-totals.component.html',
  styleUrls: ['./fee-totals.component.scss']
})
export class FeeTotalsComponent {

  @Input() feeTotals = {
    'total_transaction_amount': 0,
    'total_cbre_amount': 0
  };
  @Input() transactionType: string;

  @Input() currency: string;

  constructor() {
  }

}
